// extracted by mini-css-extract-plugin
module.exports = {"note":"ReservationFormComesAtRow_note__FOlTI"};